import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import { Box, Typography } from '@mui/material'

import { IGroupEntity } from '../../models/IGroup'
import { StatusGroupLabels } from './ui/status-labels/StatusLabels'

const GroupBarn = (props: IGroupEntity) => {
	return (
		<Box display={'flex'} flexDirection={'row'} justifyContent='space-between'>
			<Box
				display={'flex'}
				flexDirection={'row'}
				alignItems={'center'}
				gap={'8px'}
			>
				<Typography
					sx={{
						fontWeight: 700,
						fontSize: '20px',
						lineHeight: '24px',
					}}
				>
					{props.title}
				</Typography>
				<Typography
					sx={{
						fontWeight: 400,
						color: '#7F7F84',
						fontSize: '14px',
						lineHeight: '17px',
					}}
				>
					{props.barntitle}
				</Typography>
				{props.status && <StatusGroupLabels status={props.status} />}
			</Box>
			<ArrowForwardIosIcon sx={{ color: '#7F7F84' }} />
		</Box>
	)
}

export default GroupBarn
